import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Constants
import { WEB_SERVICE } from "../../config/constants";
// Components
import {
  Body,
  Header,
  LogoImg,
  OkContainer,
  WrongContainer,
  CoachImg,
  OkContainerInfo,
  WrongContainerInfo,
  Title,
  Text,
  DeepLink,
} from "./styles";
import Loader from "../loader";
import UseFetch from "../../config/useFetch";
// Assets
import RGSLogo from "../../assets/rgs_plus_logo.png";
import CoachOk from "../../assets/coach_ok.png";
import CoachWrong from "../../assets/coach_wrong.png";

const VerifyEmailUI = () => {
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [token] = useState(window.location.pathname.split("/")[2]);

  const [t] = useTranslation("global");

  // Verify email Api
  useEffect(() => {
    const handleSetToken = async () => {
      if (!token) return setIsLoadingData(false);

      await UseFetch("post", `${WEB_SERVICE}/patient/verify-email`, new AbortController(), {
        token,
      })
        .then(({ data }) => {
          if (data.emailVerified) setIsEmailVerified(true);
          setIsLoadingData(false);
        })
        .catch((error) => {
          console.log("Verify email: ", error);
          setIsLoadingData(false);
        });
    };
    handleSetToken();

    return () => {
      setIsLoadingData(true);
      setIsEmailVerified(false);
    };
  }, [token]);

  const getDeviceType = () => {
    const ua = navigator.userAgent || window.opera;
    const isAndroid = /android/i.test(ua);
    const isIOS = /iPhone|iPad|Macintosh|iPod/i.test(ua);
    return isAndroid || isIOS;
  };

  const renderCoachOK = () => {
    return (
      <OkContainer>
        <CoachImg src={CoachOk} alt="coach-ok" />
        <OkContainerInfo>
          <Title>{t("verifiedAccountTitle")}</Title>
          <Text>{t("verifiedAccountPrompt")}.</Text>
          {getDeviceType() && <DeepLink href="unitydl://mylink?rgs_account_verified">{t("goBackToRGS")}</DeepLink>}
        </OkContainerInfo>
      </OkContainer>
    );
  };

  const renderCoachWrong = () => {
    return (
      <WrongContainer>
        <WrongContainerInfo>
          <Title>{t("expiredLinkTitle")}</Title>
          <Text>{t("expiredLinkPrompt")}.</Text>
        </WrongContainerInfo>
        <CoachImg src={CoachWrong} alt="coach-wrong" />
      </WrongContainer>
    );
  };

  return (
    <Body>
      <Header marginBottom={isEmailVerified ? "16px" : "32px"}>
        <LogoImg src={RGSLogo} alt="logo" />
      </Header>
      {isLoadingData ? <Loader /> : isEmailVerified ? renderCoachOK() : renderCoachWrong()}
    </Body>
  );
};

export default VerifyEmailUI;
